import * as sentry from '@sentry/core';
import type { LogLevel } from './index.ts';

type SentrySeverityLevel = 'fatal' | 'error' | 'warning' | 'log' | 'info' | 'debug';

export const sentrySeverityMap = {
  log: 'log',
  info: 'info',
  error: 'error',
  warn: 'warning',
} as const satisfies Record<LogLevel, SentrySeverityLevel>;

export function captureException(level: LogLevel, error: unknown, params?: unknown) {
  const context = {
    level: sentrySeverityMap[level],
    extra: params as Record<string, unknown> | undefined,
  };

  if (error instanceof Error) {
    sentry.captureException(error, context);
  } else {
    const message = typeof error === 'string' ? error : JSON.stringify(error);
    sentry.captureMessage(message, context);
  }
}
